import type { IValidatedResponse } from '../../../httpClient';
import { postRequest } from '../../../httpClient';
import type { ICreateDebugRequest } from './create-debug-request';
import type { ICreateDebugResponse } from './create-debug-response';
import { createDebugResponseSchema } from './create-debug-response';

export async function createDebugApi(
  body: ICreateDebugRequest,
): Promise<IValidatedResponse<ICreateDebugResponse>> {
  return postRequest<ICreateDebugResponse>({
    path: '/sys/debug',
    body,
    schema: createDebugResponseSchema,
  });
}
